<template>

  <div class="workbench">
    <el-row :gutter="10">
      <el-col :xs="24" :md="12">
        <div class="card_botm p0">
          <el-card class="box-card">
            <div slot="header" class="clearfix">
              <span>入场记录</span>
            </div>
            <div>
              <el-table :data="inData" height="550" style="width: 100%" ref="inTable" highlight-current-row
                :row-class-name="tableRowClassName">
                <el-table-column label="识别时间/车牌号" min-width="160" align="center">
                  <template slot-scope="scope">
                    {{ scope.row.created_at }}
                    <br>
                    {{ scope.row.plate_code }}
                  </template>
                </el-table-column>
                <el-table-column label="授权方式/是否通过" min-width="160" align="center">
                  <template slot-scope="scope">
                    {{ showAuthType(scope.row.auth_type) }}
                    <br>
                    {{ showPassStatus(scope.row.pass_status) }}
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <pagination @handleSizeChange="inSizeChange" @handleCurrentChange="inCurrentChange" :page="inPage"
              :size="inPageSize" :total="inTotal"></pagination>
          </el-card>
        </div>
      </el-col>
      <el-col :xs="24" :md="12">
        <div class="card_botm p0 ">
          <el-card class="box-card">
            <div slot="header" class="clearfix">
              <span>离场状态记录</span>
            </div>
            <div>
              <el-table :data="outData" height="615" style="width: 100%" ref="outTable" highlight-current-row
                :row-class-name="tableRowClassName">
                <el-table-column label="识别时间/车牌号" min-width="160" align="center">
                  <template slot-scope="scope">
                    {{ scope.row.created_at }}
                    <br>
                    {{ scope.row.plate_code }}
                  </template>
                </el-table-column>
                <el-table-column label="授权方式/是否通过" min-width="160" align="center">
                  <template slot-scope="scope">
                    {{ showAuthType(scope.row.auth_type) }}
                    <br>
                    {{ showPassStatus(scope.row.pass_status) }}
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </el-card>
        </div>
      </el-col>
    </el-row>
    <div class="open_walk" @click="openwalk()">人行门开门</div>
    <div class="open" @click="open()">匝道开门</div>
    <!-- 匝道开门 -->
    <el-dialog title="匝道开门" :visible.sync="dialogOpen" :show-close="false" :center="true" width="500px">
      <el-form :model="openForm" status-icon ref="openForm" label-width="100px" class="demo-openForm">
        <el-form-item label="场地：">
          <loadSelect ref="loadSelect"
            :obj="{
              modelVal:placeId,
              disabled:false,
              optionVal:'place_id',
              optionName:'place_name',
              placeholder:'请选择'}"
            :url="'deviceManage/listPlace'" :formData="formFieldData" :parameter="false" @changeFn="changePlaceField">
          </loadSelect>
        </el-form-item>
        <el-form-item label="设备：">
          <loadSelect ref="loadSelect"
            :obj="{modelVal:placeDeviceId,disabled:false,optionVal:'place_device_id',optionName:'device_name',placeholder:'请选择' }"
            :url="'deviceManage/getDeviceListByPlaceId'" :formData="formDeviceData" :parameter="{ place_id: this.placeId}"
            @changeFn="changePlaceDeviceId"></loadSelect>
        </el-form-item>
        <el-form-item label="放行设备：">
          <loadSelect ref="loadSelect"
            :obj="{modelVal:deviceId,disabled:false,optionVal:'device_id',optionName:'device_name',placeholder:'请选择' }"
            :url="'deviceManage/getDeviceListByPlaceIdAndDevice'" :formData="formDeviceData" :parameter="{ place_id: this.placeId, place_device_id: this.placeDeviceId}"
            @changeFn="changeDeviceId"></loadSelect>
        </el-form-item>
        <div class="btn">
          <el-button round @click="dialogOpen = false">取消</el-button>
          <el-button type="primary" round @click="openSubmit( )">确定起匣</el-button>
          <el-button type="warning" round @click="closeSubmit( )">确定落匣</el-button>
        </div>
      </el-form>
    </el-dialog>

    <el-dialog title="人行门开门" :visible.sync="dialogWalkOpen" :show-close="false" :center="true" width="400px">
      <el-form :model="openForm" status-icon ref="openForm" label-width="100px" class="demo-openForm">
        <el-form-item label="场地：">
          <loadSelect ref="loadSelect"
            :obj="{
              modelVal:placeId,
              disabled:false,
              optionVal:'place_id',
              optionName:'place_name',
              placeholder:'请选择'}"
            :url="'deviceManage/listPlace'" :formData="formFieldData" :parameter="false" @changeFn="changePlaceField">
          </loadSelect>
        </el-form-item>
        <div class="btn">
          <el-button round @click="dialogWalkOpen = false">取消</el-button>
          <el-button type="primary" round @click="openWalkSubmit( )">确定开门</el-button>
        </div>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
  import Util from '../../Util'
  import pagination from "../../components/pagination"
  import loadSelect from "../../components/loadSelect"
  import tooltip from "../../components/tooltip"
  import modal from '../../components/modal'
  export default {
    components: {
      pagination,
      loadSelect,
      tooltip,
      modal
    },
    data() {
      return {
        placeId: '',
        placeDeviceId: '',
        deviceId: '',
        showTyper: 0,    //输入法的值，0表示不显示，1表示显示省输入键盘，2表示显示数字字母输入键盘
        provinces:[
          "川", "京", "沪", "粤", "津", "冀", "豫", "云", "辽",
          "黑", "湘", "皖", "鲁", "新", "苏", "浙", "赣", "鄂",
          "桂", "甘", "晋", "陕", "吉", "闽", "贵", "渝",
          "青", "藏", "琼", "宁", "蒙", "使", "领", "关闭"],
        keyNums:["0","1","2","3","4","5","6","7","8","9",     //数字字母
                 "Q","W","E","R","T","Y","U","I","O","P",
                 "A","S","D","F","G","H","J","K","L",
                 "Z","X","C","V","B","N","M",
                 "挂","学","警","港","澳", "删除", "清空", "提交"],
        carNumber:"",    //输入的值
        inPage: 1,
        inPageSize: 50,
        inTotal: 0,
        outPage: 1,
        outPageSize: 50,
        outTotal: 0,
        inPicture: true,
        outPicture: false,
        special: false,
        collect: false,
        dialogOpen: false,
        dialogWalkOpen: false,
        dialogCloseOpen: false,
        specialForm: {
          platDeviceId: "",
          direction: 1,
          reasonType: "",
          payFee: "",
          reasonContent: "",
          openOrder: 0,
          deviceId: ""
        },
        collectMoneyForm: {
          // platDeviceId: ""
          deviceId: ""
        },
        openForm: {
          place_id: '',
          place_device_id: '',
          device_id: '',
        },
        openWalkFrom: {
          place_id: '',
          place_device_id: '',
          device_id: '',
        },
        platId: '',
        carNum: "", //列表定时刷新时，存的车牌号
        queryCarNum: "", //搜索的车牌号
        reasonList: [{
          value: 0,
          label: '以其他价格放行'
        }, {
          value: 1,
          label: '不收费放行'
        }],
        directionList: [{
            value: 1,
            label: '进'
          },
          {
            value: 2,
            label: '出'
          }
        ],
        inData: [],
        outData: [],
        currentCar: {
          plat_id: ''
        }, //车辆信息对象
        checkCar: null, //点击记录赋值，实时上报时为true
        platDeviceList: [],
        websock: null, //实时上报对象
        actions: {}, //实时上报需要传的参数
        wsObj: null, //实时上报上来的数据对象
        formDeviceData: { //设备分页
          page: 1,
          size: 50
        },
        formFieldData: { //场地分页
          page: 1,
          size: 50
        },
        wsOpen: true, //记录ws心跳的变量
        // inCarSlot: {}
        modifyDialog: false,
        modifyForm: {
          carsNumber: '',
          usedCarsNumber: '',
          platId: ''
        },
        customForm: {
          inAuth: '',
          platId: ''
        },
        inImage: null,
        outImage: null,
        imgMode: 0,
        imgLocalUrl: 'http://192.168.3.242',
        imgGlobalUrl: 'https://img.parking.cxiot.cc',
        imgRate: 15,
        showStream: false,
        pickupInDevice:'',
        pickupOutDevice:'',
        inDoorDevices: [],
        outDoorDevices: []
      }
    },
    computed: {
      fullscreenLoading() {
        return this.$store.state.fullscreenLoading;
      },
      userInfo() {
        return this.$store.state.userInfo;
      },
      timetick() {
        return parseInt(new Date().getTime()/1000);
      }
    },
    mounted() {
      this.getInData()
      this.getOutData()
      this.getSetInterval()
    },
    beforeDestroy() {
      clearInterval(this.timer)
    },
    watch: {
    },
    methods: {
      append() {
        this.queryCarNum = '';
      },
      clearappend() {
        this.queryCarNum = '';
      },
      resetFreeWay() {
        this.openForm.deviceId = ''
      },
      showAuthType(val) {
        switch (val) {
          case 1:
            return "自动识别";
          case 2:
            return "手动处理";
        }
      },
      showPassStatus(val) {
        switch (val) {
          case 0:
            return "禁止通行";
          case 1:
            return ">已放行";
        }
      },
      onOfferTap: function () {   //对最终结果进行判断
          // var carNumberReg = /^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[A-Z]{1}[A-Z0-9]{4}[A-Z0-9挂学警港澳]{1}$/;
          // if (!carNumberReg.test(this.carNumber)) {
          //     console.log('请输入正确的车牌号码');
          //     return;
          // }
      },
      onTypewriting:function () {    //点击输入框时，弹出键盘
        this.showTyper = 1;
        this.changeTyper();
      },
      changeTyper:function () {    //判断输入的车牌号处于什么状态，为空？已输入第一个值（即省）？输入省之后的值？
          if(this.carNumber.length>=1){
              this.showTyper = 2;
          }
          if(this.carNumber.length==0){
              this.showTyper = 1;
          }
      },
      input:function (item) {    //键盘点击事件，传入键盘本身的值
          if(item=='提交'||item=='关闭'){    //判断是否点击了关闭按钮
              this.showTyper = 0;
              if(item=="提交") {
                this.addCar();
              }
              return;
          }
          if (item=='删除'){    //判断是否点击了删除按钮
              this.carNumber = this.carNumber.slice(0,-1);
              this.changeTyper();
              return;
          }
          if (item=='清空'){    //判断是否点击了删除按钮
              this.carNumber = '';
              this.changeTyper();
              return;
          }

          if(this.carNumber.length<10){    //判断当前的车牌号的数目是否合法，还未超出7位则可继续输入
              this.carNumber=this.carNumber+item;
              this.changeTyper();
          }else {
              console.log('车牌号码超出正常范围');
          }
      },

      // ws心跳
      wsSetInterval() {
        if (!this.wsOpen) return
        this.wsOpen = false
        this.wsOpenTimer = setInterval(() => {
          this.websocketsend(JSON.stringify(this.actions));
          this.wsOpen = true
        }, 1000 * 10)
      },
      initWebSocket() { //初始化weosocket
        const wsuri = Util.wsURL;
        if ("WebSocket" in window) {
          this.websock = new WebSocket(wsuri);
        } else if ("MozWebSocket" in window) {
          this.websock = new MozWebSocket(wsuri);
        } else {
          this.websock = new SockJS(wsuri);

        }
        this.websock.onmessage = this.websocketonmessage;
        this.websock.onopen = this.websocketonopen;
        this.websock.onerror = this.websocketonerror;
        this.websock.onclose = this.websocketclose;
      },
      websocketonopen() { //连接建立之后执行send方法发送数据
        this.actions = {
          "token": Util.getCookie('token'),
          "platDeviceId": this.platDeviceId,
          "action": 1
        };
        this.websocketsend(JSON.stringify(this.actions));
      },
      websocketsend(Data) { //数据发送
        console.log('数据发送');
        console.log(Data);
        this.websock.send(Data);
      },
      websocketonerror() { //连接建立失败重连
        console.log("连接建立失败重连")
        setTimeout(
          () => {
            this.initWebSocket()
          }, 1000 * 5
        );
      },
      websocketonmessage(e) { //数据接收

        if (e.data instanceof Blob) {
          const reader = new FileReader();
          var result = ''
          reader.readAsText(e.data, "UTF-8");
          reader.onload = (e) => {
            this.wsObj = JSON.parse(reader.result);
            console.log('数据接收arrayBuffer')
            console.log(this.wsObj)
            this.checkCar = true
            if(this.wsObj.direction == 2) {
              this.query(this.wsObj.carNo)
            } else if (this.wsObj.direction == 1) {
              this.queryCarNum = ""
              this.carNumber = this.wsObj.carNo;
            }
          };
        } else {
          this.wsObj = JSON.parse(e.data);
          console.log('数据接收')
          console.log(this.wsObj)
          this.checkCar = true
          if(this.wsObj.direction == 2) {
            this.query(this.wsObj.carNo)
          } else if (this.wsObj.direction == 1) {
            this.queryCarNum = ""
            this.carNumber = this.wsObj.carNo;
          }
        }
      },

      websocketclose(e) { //关闭
        console.log('断开连接');
      },
      getSetInterval() {
        this.timer = setInterval(() => {
          this.getInData()
          this.getOutData()
        }, 1000 * 60)
      },
      getInData() {
        let params = {
          page: this.inPage,
          size: this.inPageSize
        };
        this.$http.post(`${Util.searchURL}deviceManage/listInCar`, params).then(
          res => {
            if (res.data.code === 200) {
              let d = res.data.data
              this.inData = d.data
              this.inTotal = d.pageInfo.total
            }
          },
          err => {
            console.log(err);
          }
        );
      },
      ab2hex(buffer) {
        console.log(buffer);
        var hexArr = Array.prototype.map.call(
          new Uint8Array(buffer),

          function(bit) {
            return (bit.toString(16));
          }
        );
        console.log(hexArr);
        hexArr.reverse();
        return hexArr.join('');
      },
      getOutData() {
        let params = {
          page: this.outPage,
          size: this.outPageSize
        };
        this.$http.post(`${Util.searchURL}deviceManage/listOutCar`, params).then(
          res => {
            if (res.data.code === 200) {
              let d = res.data.data
              this.outData = d.data
              this.outTotal = d.pageInfo.total
            }
          },
          err => {
            console.log(err);
          }
        );
      },
      clickIn(val) {
        if (val) {
          // this.$refs.outTable.setCurrentRow();
          // this.$refs.inTable.setCurrentRow(val);
          // this.checkCar = val
          // this.wsObj = null
          // this.query(val.car_no)
        }
      },
      clickOut(val) {
        if (val) {
          this.$refs.inTable.setCurrentRow();
          this.$refs.outTable.setCurrentRow(val);
          this.checkCar = val
          this.wsObj = null
          this.query(val.car_no)
        }
      },
      //   查询详情
      query(val) {
        let carNo
        if (val) {
          this.carNum = val
        } else {
          this.checkCar = null
          this.carNum = this.queryCarNum
          this.$refs.outTable.setCurrentRow();
          this.$refs.inTable.setCurrentRow();
        }
        carNo = this.carNum
        this.$http.post(`${Util.searchURL}parking/checkCurrentParkingFeeByCarNo`, {
          carNo: carNo,
          idx: this.checkCar && this.checkCar.idx || "",
          type: 1 //使用数据库模糊查找
        }).then(
          res => {
            if (res.data.code === 200 || res.data.code === 404) {
                if(res.data.data.data){
                    this.currentCar = res.data.data.data
                }
              if (this.wsObj ) {
                this.currentCar.car_out_image = this.wsObj.base64 ? "data:image/png;base64," + this.wsObj.base64 : ""
              }
            }
          },
          err => {
            console.log(err);
          }
        );
      },
      changeReason() {
        if (this.specialForm.reasonType == 0) {
          this.specialForm.reasonContent = ""
        } else if (this.specialForm.reasonType == 1) {
          this.specialForm.payFee = ""
        }
      },
      //   点击特殊放行-弹框
      specialFn() {
        this.special = true
        this.specialForm = {
          deviceId: '',
          // platDeviceId: '',
          reasonType: '',
          reasonContent: '',
          payFee: '',
          direction: 2,
          openOrder: 0 //0 表示需要开门 1 不需要开门
        }
        if (this.userInfo.userType != 1) {
          this.platDeviceList = []
        }
      },

      //   特殊放行-接口
      specialSubmit() {
        let deviceId
        if (this.userInfo.userType == 1) {
          // this.specialForm.platDeviceId = this.platDeviceId
          this.specialForm.deviceId = this.pickupOutDevice;
        }
        if (this.specialForm.reasonType == 0) {
          this.specialForm.reasonContent = "以其他价格放行"

        } else if (this.specialForm.reasonType == 1) {
          this.specialForm.payFee = 0
        }
        if (this.wsObj) {
          this.specialForm.base64Img = "data:image/png;base64," + this.wsObj.base64
        }
        this.specialForm.base64Img = this.currentCar.car_out_image
        this.specialForm.orderId = this.currentCar.order_id
        this.specialForm.openOrder = parseInt(this.specialForm.openOrder)
        this.specialForm.deviceId = this.pickupOutDevice;
        this.$refs["specialForm"].validate((valid) => {
          if (valid) {
            this.$http.post(`${Util.operateURL}device/openDoor`, this.specialForm).then(
              res => {
                if (res.data.code === 200) {
                  Util.message("suc", res.data.desc)
                  this.special = false
                } else {
                  Util.message("err", res.data.desc)
                  if (this.specialForm.reasonType != 0) {
                    this.specialForm.payFee = ""
                  }
                  if (this.specialForm.reasonType != 1) {
                    this.specialForm.reasonContent = ""
                  }
                }
                this.query(this.carNum)
              },
              err => {
                console.log(err);
              }
            );
          } else {
            return false;
          }
        });
      },
      //   点击收费放行-弹窗
      collectMoneyFn() {
        if (this.userInfo.userType != 1) {
          this.collect = true
          // this.collectMoneyForm.platDeviceId = ""
          this.collectMoneyForm.deviceId = ""
          this.platDeviceList = []
        } else {
          this.collect = true
          //this.collectMoney()
        }

      },
      //   收费放行-接口
      collectMoney(deviceId) {
        this.$http.post(`${Util.operateURL}device/payOpenDo`, {
          orderId: this.currentCar.order_id,
          payFee: this.currentCar.pay_fee,
          stopTimeLen: this.currentCar.stop_time,
          // platDeviceId: platDeviceId ? this.collectMoneyForm.platDeviceId : this.platDeviceId,
          deviceId: this.pickupOutDevice
          // base64Img: this.wsObj && this.wsObj.base64 ? "data:image/png;base64," + this.wsObj.base64 : '',
        }).then(
          res => {
            if (res.data.code === 200) {
              this.collect = false
              Util.message("suc", res.data.desc)
            } else {
              Util.message("err", res.data.desc)
            }
            this.query(this.carNum)
          },
          err => {
            console.log(err);
          }
        );
      },
      changePlaceField(val) {
        this.placeId = val
        this.openForm.place_id = val;
        this.openForm.place_device_id = "";
        this.openForm.device_id = "";
        // this.pickupInDevice = '';
        // this.pickupOutDevice = '';
      },
      changePlaceDeviceId(val) {
        this.placeDeviceId = val;
        this.openForm.place_device_id = val;
        this.openForm.device_id = ""
      },
      changeDeviceId(val) {
        this.deviceId = val;
        this.openForm.device_id = val;
      },
      //   匝道开门-弹框
      open() {
        this.dialogOpen = true
        this.openForm.place_id = ""
        this.openForm.place_device_id = ""
        this.openForm.device_id = ""
        this.placeId = ""
        this.placeDeviceId = ""
        this.deviceId = ""
      },
      openwalk() {
        this.dialogWalkOpen = true
        this.openWalkFrom.place_id = ""
        this.openWalkFrom.place_device_id = ""
        this.openWalkFrom.device_id = ""
        this.placeId = ""
        this.placeDeviceId = ""
        this.deviceId = ""
      },
      //   匝道开门-接口
      openSubmit() {
        this.$refs["openForm"].validate((valid) => {
          if (valid) {
            this.$http.post(`${Util.operateURL}deviceManage/openGate`, this.openForm).then(
              res => {
                if (res.data.code === 200) {
                  this.dialogOpen = false
                  Util.message("suc", res.data.desc)
                } else {
                  Util.message("err", res.data.desc)
                }
              },
              err => {
                console.log(err);
              }
            );
          } else {
            return false;
          }
        })
      },
      //   匝道关门-接口
      closeSubmit() {
        this.$refs["openForm"].validate((valid) => {
          if (valid) {
            this.$http.post(`${Util.operateURL}deviceManage/closeGate`, this.openForm).then(
              res => {
                if (res.data.code === 200) {
                  this.dialogOpen = false
                  Util.message("suc", res.data.desc)
                } else {
                  Util.message("err", res.data.desc)
                }
              },
              err => {
                console.log(err);
              }
            );
          } else {
            return false;
          }
        })
      },
      //  行人道开门-接口
      openWalkSubmit() {
        this.$refs["openForm"].validate((valid) => {
          if (valid) {
            this.$http.post(`${Util.operateURL}deviceManage/openWalkSide`, this.openForm).then(
              res => {
                if (res.data.code === 200) {
                  this.dialogWalkOpen = false
                  Util.message("suc", res.data.desc)
                } else {
                  Util.message("err", res.data.desc)
                }
              },
              err => {
                console.log(err);
              }
            );
          } else {
            return false;
          }
        })
      },
      isNumber2(val) {
        return Util.isNumber2(val)
      },
      tableRowClassName({
        row,
        rowIndex
      }) {
        if (this.checkCar && this.checkCar.idx == row.idx) {
          return " tr-ba-clor";
        }
        return "";
      },
      //   每页页数改变时
      inSizeChange(val) {
        this.inPage = 1
        this.inPageSize = val
        this.getInData()
      },
      outSizeChange(val) {
        this.outPage = 1
        this.outPageSize = val
        this.getOutData()
      },
      //   改变页数时
      inCurrentChange(val) {
        this.inPage = val
        this.getInData()
      },
      outCurrentChange(val) {
        this.outPage = val
        this.getOutData()

      },
      forceUpdate() {
        this.$forceUpdate()
      },
      modifyPlat() {
        this.modifyDialog = true
        this.getFieldMsg()
      },
      getFieldMsg(cb) {
        console.log(this.platDeviceId);
        if (this.$refs['modifyForm']) {
          this.$refs['modifyForm'].resetFields();
        }
        if (this.$refs['customForm']) {
          this.$refs['customForm'].resetFields();
        }
        this.$http.post(`${Util.searchURL}premises/get`, {
          platDeviceId: this.platDeviceId
        }).then(
          res => {
            if (res.data.code === 200) {
              let d = res.data.data.data
              this.modifyForm.platId = d.plat_id
              this.modifyForm.carsNumber = d.cars_number
              this.modifyForm.usedCarsNumber = d.used_cars_number
              this.customForm.platId = d.plat_id
              this.customForm.inAuth = d.in_auth
              console.log(this.customForm);
              if(cb) {
                cb();
              }
            }
          },
          err => {
            console.log(err);
          }
        )
      },
      modifySubmit() {
        this.$refs["modifyForm"].validate((valid) => {
          if (valid) {
            console.log(this.modifyForm);
            this.$confirm(`确定更新`, '修改场地车辆', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
                callback: action => {
                  if (action === 'confirm') {
                    let url = `${Util.operateURL}platInfo/updateUseCarAnd`
                    this.$http.post(url, this.modifyForm).then(
                      res => {
                        if (res.data.code === 200) {
                          this.modifyDialog = false
                          Util.message("suc", res.data.desc)
                        } else {
                          Util.message("err", res.data.desc)
                        }
                      },
                      err => {
                        console.log(err);
                      }
                    );
                  } else {

                  }
                }
            });
          } else {
            return false;
          }
      });
    },
    setOpenStatus(val) {
      let url = `${Util.operateURL}platInfo/updateisOpen`
      this.$http.post(url, this.customForm).then(
        res => {
          if (res.data.code === 200) {
            Util.message("suc", res.data.desc)
          } else {
            Util.message("err", res.data.desc)
          }
        },
        err => {
          console.log(err);
        }
      );
    },
    cbOpen() {
      console.log()
      if(this.customForm.inAuth) {
        if(this.modifyForm.usedCarsNumber >= this.modifyForm.carsNumber) {
          console.log('NO SIZE');
          return
        }
      } else {
        console.log('no pass');
        return;
      }
      this.openForm.deviceId = this.pickupInDevice;
      this.openForm.direction = 1;
      this.$http.post(`${Util.operateURL}device/noPayOpenDo`, this.openForm).then(
        res => {
          if (res.data.code === 200) {
            Util.message("suc", res.data.desc)
          } else {
            Util.message("err", res.data.desc)
          }
        },
        err => {
          console.log(err);
        }
      );
    },
  }
}
</script>

<style lang="less">
  .workbench {
    .el-card__header {

      .clearfix {
        color: #fff;
        text-align: center;
        font-size: 18px;
        margin: -18px -20px;
        background: #409EFF;
        height: 40px;
        line-height: 40px;
      }
    }

    .hei_200 {
      height: 214px;
    }

    .hei_220 {
      height: 235px;
    }

    .hei_450 {
      height: 573px;
      overflow-y: auto;

      h2 {
        text-align: center;
        padding: 20px 0px 40px 0px;
      }

      p {
        line-height: 30px;
        font-size: 20px;

        span {
          color: red;
          font-size: 28px
        }
      }
    }

    .no_picture {
      line-height: 200px;
      text-align: center;
    }

    .card_botm {
      margin-bottom: 20px;

      img {
        width: 100%;
        min-width: 150px;
        height: 240px;
      }
    }

    .btn {
      margin-top: 54px;
      text-align: center;

      button {
        width: 108px;
        padding: 6px 25px;
        margin-bottom: 5px;
      }
    }

    .el-table__body {
      width: 100%
    }

    .p0 {
      .el-card__body {
        padding: 0px !important;
      }

      .el-card__header {
        border-bottom: none
      }

      .el-table td,
      .el-table th {
        padding: 3px 0;
      }
    }

    .tr-ba-clor {
      background-color: #ecf5ff !important;
    }

    .open {
      position: fixed;
      border: 1px solid #79ace0;
      width: 30px;
      z-index: 1000;
      right: 20px;
      top: 50%;
      background: #79ace0;
      border-radius: 5px;
      text-align: center;
      padding: 5px 0px;
      color: #fff;
      cursor: pointer;
    }

    .open:hover {
      border: 1px solid #409eff;
      background: #409eff;
    }

    .open_walk {
      position: fixed;
      border: 1px solid #79ace0;
      width: 30px;
      z-index: 1000;
      right: 20px;
      top: 20%;
      background: #79ace0;
      border-radius: 5px;
      text-align: center;
      padding: 5px 0px;
      color: #fff;
      cursor: pointer;
    }

    // .in-car-msg {
    //   right: 0% !important;
    // }
  }

  .typer {
    width: 450px;
  }
  .typer ul{
    display:flex;
    flex-wrap: wrap;
  }
  .typer ul li{
    list-style: none;
    font-size:25px;
    width: 50px;
    height: 50px;
    text-align: center;
    line-height: 50px;
    padding-left: 10px;
  }

</style>



// WEBPACK FOOTER //
// src/page/workbench/index.vue